const scale = () => import("./pages/index");
export default [
  {
    path: '/classroom/:study/:classroom_id/:pid/scale/:resource_id',
    name: "scale-index",
    component: scale
  }
]



// WEBPACK FOOTER //
// ./src/modules/lesson-scale/routes.js